<app-requisition-precedent-form
	*ngIf="vm$ | async as vm"
	[selectedRequisitionPrecedent]="selectedRequisition"
	(onSubmit)="onSubmit($event)"
	(formStatusChange)="onFormStatusChange($event)"
>
	<div header-content class="flex flex-col">
		<h3>Edit Requisition on File</h3>
		<p>
			Edit current requisition or select a new template to add to this
			instrument.
		</p>
	</div>
	<ng-container footer-content>
		<ui-button preset="MEDIUM_EMPHASIS" (click)="closeModal()" label="Cancel" />
		<ui-button
			preset="HIGH_EMPHASIS"
			type="submit"
			[loading]="vm.loading"
			[disabled]="isDisabled"
			label="Save"
		/>
	</ng-container>
</app-requisition-precedent-form>
